import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmotions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 16H4M28 16H30",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.995 30.0049L15.995 28.0049M15.995 4.00488L15.995 2.00488",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9958 28.1318L21.9958 26.3998M9.99579 5.61518L8.99579 3.88313",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.122 23.0093L26.39 22.0093M5.60535 10.0093L3.8733 9.00928",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.1271 9.00928L26.395 10.0093M5.61041 22.0093L3.87836 23.0093",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0045 3.88306L22.0045 5.61511M10.0045 26.3997L9.00445 28.1318",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8877 4C21.0915 4.85524 24.7071 9.91877 23.8829 15.3185C23.2235 19.6384 19.3142 22.5856 15.1512 21.9013C11.8208 21.354 9.54855 18.1088 10.0761 14.653C10.4981 11.8883 13 10.002 15.6643 10.4399C17.7958 10.7903 19.25 12.8672 18.9124 15.0789C18.6423 16.8483 17.0411 18.0555 15.3359 17.7752",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEmotions;
